import { ToastContainerProps } from 'react-toastify'

import * as S from './styles'

const ToastContainer = (props: Omit<ToastContainerProps, 'theme'>) => (
  <S.Wrapper {...props} />
)

export default ToastContainer
